/* eslint jsx-a11y/heading-has-content: 0 */

import "../../style/pages/Vacancies.scss";

const vacancies = [
  {
    title: "Systeembeheerder - Specialisatie Microsoft 365",
    subTitle:
      "Binnen Topassist ben je als systeembeheerder samen met je collega's verantwoordelijk voor het dagelijkse remote- en on - sitebeheer en - monitoring van de ICT omgeving van onze klanten.",
    contentHtml: (
      <>
        <p>
          Het opbouwen van nieuwe ICT omgevingen en het opstellen van nieuwe
          processen, procedures, documentatie en werkinstructies.
        </p>
        <p>
          Je bent een teamspeler die verantwoordelijkheid durft te nemen, sterk
          is in het oplossen van (soms complexe) technische vraagstukken en
          graag werkt in een veelzijdige omgeving.
        </p>
        <p>
          Met de specialisatie Microsoft 365 ben je verantwoordelijk voor het
          beheer en onderhoud van alle onderdelen binnen deze omgeving van onze
          klanten.
        </p>
        <div>
          <h2 className="sub-header">
            Heb je zin om hiermee bij Topassist aan de slag te gaan?
          </h2>
          <ul>
            <li>
              Je hebt goede kennis van of certificering en ervaring in Microsoft
              365, Azure en netwerkinfrastructuren
            </li>
            <li>Je hebt een analytisch en probleemoplossend vermogen</li>
            <li>Je bent zelfstandig, proactief en communicatief sterk</li>
            <li>Je bent in het bezit van rijbewijs B</li>
          </ul>
        </div>
        <div>
          <h2 className="sub-header">Dan bieden wij jou</h2>
          <ul>
            <li>
              Een marktconform salaris wat past bij jouw ervaring en kwaliteiten
            </li>
            <li>
              Deelname aan uitstekende pensioenregeling - 100% vergoed door
              Topassist
            </li>
            <li>
              Een veelzijdige, prettige werkomgeving waar jouw input wordt
              gewaardeerd
            </li>
            <li>Auto van de zaak of kilometervergoeding</li>
            <li>Ruimte voor persoonlijke en professionele ontwikkeling</li>
            <li>Dagelijks lunch op kantoor</li>
            <li>Kortom: een baan met veel variatie en mogelijkheden.</li>
          </ul>
        </div>
        <p>
          Lijkt het je wat? Bel ons gerust! We gaan dan graag met je in gesprek
          om uit te leggen wat onze visie is.
          <br />
          Mailen mag natuurlijk ook.
        </p>
        <ul>
          <li>
            Telefoon: <a href="tel:0165 745 295">0165745295</a>
          </li>
          <li>
            E-mailadres:{" "}
            <a href="mailto:info@topassist.nl">info@topassist.nl</a>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Helpdesk&shy;medewerker / BBL-er",
    subTitle:
      "Ben jij die beginnend ICT'er die graag met alle facetten van ICT in aanraking komt, en draai je je hand niet om voor de meest uiteenlopende taken? Dan zou je wel eens goed in ons team kunnen passen!",
    contentHtml: (
      <>
        <div>
          <h2 className="sub-header">Wat wij bieden</h2>
          <ul>
            <li>
              Een gevarieerde verzameling van werkzaamheden, je zal je niet snel
              gaan vervelen.
            </li>
            <li>
              Gezellige en behulpzame collega's met tijd voor een grapje en een
              praatje.
            </li>
            <li>Een prettige, informele en toch professionele werksfeer.</li>
            <li>Vrijmibo, en voor een lichte lunch wordt altijd gezorgd.</li>
            <li>
              Een marktconform salaris met aantrekkelijke secundaire
              arbeidsvoorwaarden.
            </li>
            <li>Goede pensioenvoorziening.</li>
            <li>
              Kansen om jezelf te ontwikkelen binnen ons groeiende bedrijf.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="sub-header">Geïnteresseerd of vragen?</h2>
          <ul>
            <li>
              Bel ons op <a href="tel:0165 745 295">0165-745295</a>, en vraag
              naar Robin of Piet.
            </li>
            <li>
              Stuur direct een e-mail naar{" "}
              <a href="mailto:r.walraven@topassist.nl">
                r.walraven@topassist.nl
              </a>
              .
            </li>
          </ul>
        </div>
      </>
    ),
  },
];

export default function Vacancies() {
  return (
    <div className="vacancies-page panel-page">
      <title>Vacatures - Topassist</title>
      <meta
        name="description"
        content="Werken in IT en netwerkbeheer? Bekijk onze vacatures!"
      />
      <div className="eye-catcher-container">
        <video autoPlay playsInline loop muted>
          <source src="/asset/background.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="content">
        <div className="panel over-eye-catcher">
          <h1>
            Werken bij <span className="accented">Topassist</span>
          </h1>
          <h3>
            Ben jij op zoek naar een gevarieerde en interessant nieuwe baan
            binnen IT?
            <br />
            Kijk dan hier onder naar onze openstaande vacatures. Hopelijk zien
            we jou snel bij ons op kantoor!
          </h3>
        </div>

        {vacancies.map((v, i) => (
          <div className="panel vacancy" key={`vacancy-${i}`}>
            <div>
              <h1 dangerouslySetInnerHTML={{ __html: v.title }}></h1>
              <h4 dangerouslySetInnerHTML={{ __html: v.subTitle }}></h4>
            </div>
            {v.contentHtml}
          </div>
        ))}
      </div>
    </div>
  );
}
